export default __webpack_public_path__ + "static/media/decision_rejected.33bcb3c0.png";